const InputLayoutType = {
  inline: 'inline',
  outline: 'outline'
}

export default InputLayoutType;
